module.exports = "<div class=\"lds-ripple\">\n  <div></div>\n  <div></div>\n</div>"